import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useBundleCourseItemsModal from './useBundleCourseItemsModal';

import { RootState } from '@redux/reducer';

const useBundleCourseModal = (currentIndex: number) => {
  const { bundleCoursesState } = useSelector((state: RootState) => ({
    bundleCoursesState: state.Bundle.get('bundleCoursesState'),
  }));

  const { handleFetchCourse } = useBundleCourseItemsModal();

  const { data: bundleCoursesData } = bundleCoursesState;

  const getCourseIdName = () => {
    return bundleCoursesData[currentIndex].idName;
  };

  const getTotalIndex = () => {
    return bundleCoursesData.length;
  };

  const hasNextIndex = () => {
    return currentIndex < bundleCoursesData.length - 1;
  };
  const hasPreviousIndex = () => {
    return currentIndex > 0;
  };

  const nextIndex = (setCurrentIndex: (currentIndex: number) => void) => {
    setCurrentIndex(currentIndex + 1);
  };

  const previousIndex = (setCurrentIndex: (currentIndex: number) => void) => {
    setCurrentIndex(currentIndex - 1);
  };

  const courseIdName = getCourseIdName();

  useEffect(() => {
    handleFetchCourse(courseIdName);
  }, [courseIdName]);

  return {
    getTotalIndex,
    getCourseIdName,
    hasNextIndex,
    hasPreviousIndex,
    nextIndex,
    previousIndex,
  };
};

export default useBundleCourseModal;
